/* eslint-disable jira/filename-case */
// This file is still present because Monolith requires it to be here.

// Can  be cleaned up as soon as Monolith is adjusted.
